module.exports = __webpack_public_path__ + "img/bemestar.ec063446.svg";